
import Vue from "vue";
import WelcomeComponent from "@/components/signup/WelcomeComponent.vue";
export default Vue.extend({
  name: "Welcome",
  components: {
    WelcomeComponent
  }
});
